import { b } from '../../../lit-element.js';

const curtainAnimation = b`
<svg id="curtain" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path fill="#10253F" d="M 100,0 L 0,0 L 0,0 c 0,0, 50,0, 50,0 c 0,0, 50,0, 50,0 Z">
                <animate id="curtainAnimate" attributeName="d"
                       begin="indefinite" dur=".7s" fill="freeze"
                       keyTimes="0; 0.65; 1"
                       values="M 100,0 L 0,0 L 0,0 c 0,0, 50,0, 50,0 c 0,0, 50,0, 50,0 Z;
                               M 100,0 L 0,0 L 0,50 c 0,17, 23,30, 50,30 c 27,0, 50,-13, 50,-30 Z;
                               M 100,0 L 0,0 L 0,130 c 0,17, 23,30, 50,30 c 27,0, 50,-13, 50,-30 Z"/>
                <animate id="curtainAnimateReverse" attributeName="d"
                       begin="indefinite" dur=".7s" fill="freeze"
                       keyTimes="0; 0.65; 1"
                       values="M 100,0 L 0,0 L 0,130 c 0,17, 23,30, 50,30 c 27,0, 50,-13, 50,-30 Z;
                               M 100,0 L 0,0 L 0,50 c 0,17, 23,30, 50,30 c 27,0, 50,-13, 50,-30 Z;
                               M 100,0 L 0,0 L 0,0 c 0,0, 50,0, 50,0 c 0,0, 50,0, 50,0 Z"/>
            </path>
        </svg>
`;

export { curtainAnimation };
